import { createTypedOutlet } from "src/router";

import type { SyncQuery } from "src/graphql";
import type { useCurrentRun } from "src/pages/syncs/sync/utils/use-current-run";

export type PartnerSyncOutletContext = {
  sync: NonNullable<SyncQuery["syncs"][0]>;
  startRun: ReturnType<typeof useCurrentRun>["startRun"];
};

const {
  OutletProvider: PartnerSyncOutlet,
  useContext: usePartnerSyncOutletContext,
  useOptionalContext: usePartnerSyncOutletContextIfAvailable,
} = createTypedOutlet<PartnerSyncOutletContext>("PartnerSync");

export {
  PartnerSyncOutlet,
  usePartnerSyncOutletContext,
  usePartnerSyncOutletContextIfAvailable,
};
